<div
  style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center"
>
  <mat-spinner class="space" />
</div>
